// src/components/guards.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authHeader, getAccess } from "../lib/auth";
import api from "../services/api";
import { isPunchHiddenForCurrentUser } from "../lib/punchAccess";
import HelpToggle from "./HelpToggle";
import ThemeSync from "./ThemeSync";

// 出退勤（打刻）画面を表示しない社員コード（S000/S001 等）は、
// 直接URLで来ても社員証表面へ戻す
export function PunchGuard({ children, redirectTo = "/card_front" }) {
  if (isPunchHiddenForCurrentUser()) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
}

function Loading() {
  return <div style={{ padding: 12 }}>Checking permission...</div>;
}

//
function getStoredAccess() {
  return localStorage.getItem("access") ?? sessionStorage.getItem("access") ?? null;
}
/*
export function AdminRoute({ children }) {
  const [ok, setOk] = React.useState(null);

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const token = getStoredAccess();
        const res = await fetch("/api/auth/me/?_=" + Date.now(), { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) { if (alive) setOk(false); return; }
        const me = await res.json();
        //if (alive) setOk(!!(me?.is_staff || me?.is_superuser));
        if (alive) {
          const isStaff = me?.is_staff === true;
          const isSuper = me?.is_superuser === true;
          const perms = Array.isArray(me?.permissions) ? me.permissions : [];

          const hasAdminAccess = isStaff || isSuper || perms.length > 0;
          
          setOk(hasAdminAccess);
        }
      } catch { if (alive) setOk(false); }
    })();
    return () => { alive = false; };
  }, []);

  if (ok === null) return null;
  if (!ok) return <Navigate to="/admin/login" replace />;
  return <div className="admin-layout">{children}</div>;
}
*/
// src/components/guards.jsx
//
// 通過判定は必ずサーバ(/api/auth/me/)に問い合わせる。
// 以前は localStorage の adminUser があればサーバに聞かずに素通ししていたが、
// localStorage は同一ホスト名の全タブで共有されるため、同じブラウザで管理者と
// 社員の両方にログインすると「実際に送信されるトークンは社員のものなのに、
// 古い adminUser が残っているので管理画面に入れてしまう」状態になっていた。
// （bugfix_同一ブラウザ二重ログイン_20260812.md の BUG-103）
//
// サーバの応答は adminUser に書き戻す。AdminDashboard はこのキーを同期的に読んで
// アイコンの活性/グレーを決めるため、常に「今のトークンの持ち主」と一致させる。
export function AdminRoute({ children }) {
  const [ok, setOk] = React.useState(null);

  React.useEffect(() => {
    let alive = true;

    (async () => {
      try {
        if (!getStoredAccess()) { if (alive) setOk(false); return; }

        // fetch ではなく axios インスタンスを使う。401 のときにリフレッシュして
        // 1回だけ再試行するインターセプタが入っており、アクセストークンが切れた
        // だけの管理者がログイン画面に飛ばされるのを防げる。
        const { data: me } = await api.get("/api/auth/me/", { params: { _: Date.now() } });

        const isStaff = me?.is_staff === true;
        const isSuper = me?.is_superuser === true;
        const perms = Array.isArray(me?.permissions) ? me.permissions : [];
        const hasAdminAccess = isStaff || isSuper || perms.length > 0;

        if (hasAdminAccess) {
          localStorage.setItem("adminUser", JSON.stringify({
            username: me?.username ?? "",
            is_staff: isStaff,
            is_superuser: isSuper,
            permissions: perms,
          }));
        } else {
          localStorage.removeItem("adminUser");
        }

        if (alive) setOk(hasAdminAccess);
      } catch {
        if (alive) setOk(false);
      }
    })();

    return () => { alive = false; };
  }, []);

  if (ok === null) return null;
  if (!ok) return <Navigate to="/admin/login" replace />;
  

  return <div className="admin-layout">{children}</div>;
}

export function EmployeeRoute({ children, loginPath = "/m/login" }) {
  const access = getStoredAccess();
  if (!access) return <Navigate to={loginPath} replace />;
  // 全社員画面は EmployeeRoute で包まれているため、ここに1箇所置けば
  // 各画面（および今後追加される画面）に説明トグル・OSテーマ追従が自動で付く。
  // ThemeSync は管理画面には入らないので、管理側はライト固定のまま。
  return (
    <>
      {children}
      <HelpToggle />
      <ThemeSync />
    </>
  );
}
